/* LIMBIO Wasserpflege – kleines Vanilla-JS (ca. 7 KB unkomprimiert, ca. 2 KB gzip), nur Progressive Enhancement.
   Ohne JavaScript funktionieren Formulare und FAQ trotzdem.
   Mehrfach eingebunden? Die Guards unten verhindern doppelte Registrierung. */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Kaufformular: Menge + AJAX "In den Warenkorb" ---------- */
  if (!customElements.get('limbio-buy-form')) {
    customElements.define('limbio-buy-form', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        if (!this.form) return;
        this.qty = this.form.querySelector('input[name="quantity"]');
        this.button = this.form.querySelector('[type="submit"]');
        this.labelEl = this.button && this.button.querySelector('.lw-buy__label');
        this.status = this.form.querySelector('.lw-buy__status');
        this.error = this.form.querySelector('.lw-buy__error');

        this.form.querySelectorAll('[data-qty]').forEach((btn) => {
          btn.addEventListener('click', () => {
            if (!this.qty) return;
            var next = (parseInt(this.qty.value, 10) || 1) + parseInt(btn.dataset.qty, 10);
            this.qty.value = Math.min(99, Math.max(1, next));
            this.qty.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
        this.form.addEventListener('submit', (e) => this.onSubmit(e));
      }

      onSubmit(e) {
        e.preventDefault();
        if (!this.button || this.button.hasAttribute('aria-disabled')) return;
        var id = this.form.querySelector('input[name="id"]').value;
        var quantity = this.qty ? Math.max(1, parseInt(this.qty.value, 10) || 1) : 1;
        this.error.textContent = '';
        this.button.setAttribute('aria-disabled', 'true');

        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: quantity }], sections: 'cart-icon-bubble', sections_url: window.location.pathname })
        })
          .then((r) => r.json().then((data) => ({ ok: r.ok, data: data })))
          .then((res) => {
            if (!res.ok) throw new Error(res.data.description || res.data.message || 'Das hat leider nicht geklappt.');
            this.updateBubble(res.data.sections);
            this.showAdded(quantity);
            document.dispatchEvent(new CustomEvent('limbio:cart-added', { detail: { id: id, quantity: quantity } }));
          })
          .catch((err) => {
            this.error.textContent = err.message;
            this.button.removeAttribute('aria-disabled');
          });
      }

      updateBubble(sections) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (!bubble || !sections || !sections['cart-icon-bubble']) return;
        var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        var inner = doc.querySelector('.shopify-section');
        if (inner) bubble.innerHTML = inner.innerHTML;
      }

      showAdded(quantity) {
        var added = this.dataset.addedLabel || 'Im Warenkorb';
        var original = this.button.dataset.label;
        var styleClass = Array.prototype.find.call(this.button.classList, (c) => c.indexOf('lw-btn--') === 0 && c !== 'lw-btn--success');
        this.button.classList.add('lw-btn--success');
        if (styleClass) this.button.classList.remove(styleClass);
        if (this.labelEl) this.labelEl.textContent = '✓ ' + added;
        if (this.status) this.status.textContent = quantity + ' × in den Warenkorb gelegt.';
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.button.classList.remove('lw-btn--success');
          if (styleClass) this.button.classList.add(styleClass);
          if (this.labelEl) this.labelEl.textContent = original;
          this.button.removeAttribute('aria-disabled');
        }, 1800);
      }
    });
  }

  /* ---------- Reichweiten-Rechner ---------- */
  if (!customElements.get('limbio-range-calc')) {
    customElements.define('limbio-range-calc', class extends HTMLElement {
      connectedCallback() {
        this.dose = parseFloat(this.dataset.dose) || 10;          // ml pro 500 l pro Woche
        this.base = parseFloat(this.dataset.base) || 500;         // Bezugsmenge in Litern
        this.bottle = parseFloat(this.dataset.bottle) || 500;     // Flascheninhalt in ml
        this.price = parseInt(this.dataset.price, 10) || 0;       // Preis in Rappen/Cent
        this.min = parseInt(this.dataset.min, 10) || 300;
        this.max = parseInt(this.dataset.max, 10) || 3000;
        this.nf = new Intl.NumberFormat('de-CH', { maximumFractionDigits: 1 });
        this.nf0 = new Intl.NumberFormat('de-CH', { maximumFractionDigits: 0 });
        this.cf = new Intl.NumberFormat('de-CH', { style: 'currency', currency: this.dataset.currency || 'CHF' });
        this.number = this.querySelector('[data-calc-number]');
        this.range = this.querySelector('[data-calc-range]');
        var sync = (src, dst) => () => {
          var v = parseInt(src.value, 10);
          if (isNaN(v)) return;
          if (dst) dst.value = Math.min(this.max, Math.max(this.min, v));
          this.render(Math.min(this.max, Math.max(this.min, v)));
        };
        if (this.number) this.number.addEventListener('input', sync(this.number, this.range));
        if (this.range) this.range.addEventListener('input', sync(this.range, this.number));
        if (this.number) this.number.addEventListener('blur', () => { this.number.value = this.range ? this.range.value : this.number.value; });
        this.render(parseInt((this.number || this.range).value, 10));
      }

      set(key, text) {
        var el = this.querySelector('[data-out="' + key + '"]');
        if (el) el.textContent = text;
      }

      render(liters) {
        var weekly = liters / this.base * this.dose;            // ml pro Woche
        var weeks = this.bottle / weekly;                        // Wochen pro Flasche
        var months = weeks / 4.345;                              // Monate pro Flasche
        var perYear = 52 * weekly / this.bottle;                 // Flaschen pro Jahr
        this.set('weekly', this.nf.format(weekly) + ' ml');
        this.set('start', this.nf.format(weekly * 2) + ' ml');
        this.set('months', 'ca. ' + this.nf.format(months));
        this.set('year', 'ca. ' + this.nf.format(perYear));
        if (this.price) this.set('cost', this.cf.format(this.price / 100 / months));
        this.set('liters', this.nf0.format(liters) + ' Liter');
      }
    });
  }
})();
(function () {
  var mq = window.matchMedia('(min-width: 990px) and (prefers-reduced-motion: no-preference)');
  if (!mq.matches) return;
  document.querySelectorAll('.lw-hero__video-tpl:not([data-done])').forEach(function (t) {
    t.setAttribute('data-done', '');
    t.parentNode.appendChild(t.content.cloneNode(true));
    var v = t.parentNode.querySelector('video');
    if (v) { v.muted = true; v.setAttribute('aria-hidden', 'true'); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  });
})();
